function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0",
    style: {
      fill: "#e31b23"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h20v20H0",
    style: {
      fill: "#fdef42"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.213 15.42 18.166 14 15.75 14 15 11.7 14.25 14 11.833 14 13.787 15.421 13.033 17.733 15 16.303 16.967 17.733 16.213 15.42",
    style: {
      fill: "#00853f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 10,
    height: 20,
    style: {
      fill: "#00853f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSn);
export default __webpack_public_path__ + "static/media/SN.7e5ba4448fab2016df3d757b4ffd0662.svg";
export { ForwardRef as ReactComponent };